(() => {
  const aliases = { XXS: 0, XS: 1, S: 2, SMALL: 2, M: 3, MEDIUM: 3, L: 4, LARGE: 4, XL: 5, EXTRALARGE: 5, XXL: 6, '2XL': 6, XXXL: 7, '3XL': 7, '4XL': 8, '5XL': 9, '6XL': 10 };
  const rank = value => aliases[String(value).toUpperCase().replace(/[\s-]/g, '')];
  function orderedSizes(sizes, category) {
    const unique = [...new Set(sizes)];
    if (unique.length < 2) return null;
    if (unique.every(s => rank(s) !== undefined)) {
      if (new Set(unique.map(rank)).size !== unique.length) return null;
      return unique.sort((a, b) => rank(a) - rank(b));
    }
    if (category === 'bottoms' && unique.every(s => /^\d{2}(?:\.5)?$/.test(String(s)))) {
      return unique.sort((a, b) => Number(a) - Number(b));
    }
    return null;
  }
  function recommend({ sizes, category, answers }) {
    const ordered = orderedSizes(sizes, category);
    if (!ordered || !answers || !['slim', 'medium', 'fuller'].includes(answers.body) || !['comfortable', 'sometimes', 'tight'].includes(answers.feel) || !['close', 'regular', 'roomy'].includes(answers.fit)) return { status: 'unsupported' };
    const base = ordered.indexOf(answers.usual);
    if (base < 0) return { status: 'not_listed' };
    const reasons = [];
    if (answers.feel !== 'comfortable') reasons.push('tight');
    if (answers.fit === 'roomy') reasons.push('roomy');
    if (category === 'outerwear' && answers.layer === 'yes') reasons.push('layer');
    const up = reasons.length > 0;
    if (up && base === ordered.length - 1) return { status: 'recommended', size: ordered[base], adjustment: 0, capped: true, reasons };
    const next = ordered[base + (up ? 1 : 0)];
    if (up && rank(answers.usual) !== undefined && rank(next) - rank(answers.usual) !== 1) return { status: 'size_gap', reasons };
    if (up && rank(answers.usual) === undefined && Number(next) - Number(answers.usual) > 2) return { status: 'size_gap', reasons };
    return { status: 'recommended', size: next, adjustment: up ? 1 : 0, reasons };
  }
  function matchingVariant(variants, sizeIndex, selectedOptions, size) {
    return variants.find(v => v.options[sizeIndex] === size && v.options.every((option, i) => i === sizeIndex || option === selectedOptions[i])) || null;
  }
  globalThis.AWFitLogic = Object.freeze({ orderedSizes, recommend, matchingVariant });
})();
